function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Fragment, useState } from 'react';
import { Button, ConfirmationModal, Typography } from 'seagull';
import { NewTab } from 'seagull/icons';
import { CopyToClipboard } from "../../../components/CopyToClipboard/CopyToClipboard";
import { openInNewTabProps } from "../../../constants";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { useOnMount } from "../../../hooks/useOnMount";
import styles from "./CopyAPIKeyModal.module.scss";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function CopyAPIKeyModal(_ref) {
  let {
    dismissModal,
    title,
    integrationUrl,
    testId,
    getApiKey,
    onCopyApiKey,
    steps
  } = _ref;
  const [apiKey, setApiKey] = useState('');
  const [helperText, setHelperText] = useState('');
  const {
    MANAGE_API_KEYS
  } = useFeatureFlags();
  useOnMount(() => {
    if (!MANAGE_API_KEYS) {
      getApiKey().then(setApiKey).catch(() => setHelperText('API key not found. Please try again later.'));
    }
  });
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Integrate with ".concat(title),
    width: "760px",
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.modalContainer,
      children: [/*#__PURE__*/_jsxs(Typography, {
        children: ["To integrate with ", title, ", follow the next steps: "]
      }), MANAGE_API_KEYS ? /*#__PURE__*/_jsx("div", {
        className: styles.stepsContainer,
        children: steps.map((step, index) => /*#__PURE__*/_jsx(Fragment, {
          children: typeof step === 'string' ? /*#__PURE__*/_jsx(Typography, {
            children: step
          }) : step
        }, index))
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Typography, {
          children: steps[0]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.copyApiKeyContainer,
          children: /*#__PURE__*/_jsx(CopyToClipboard, {
            "data-testid": "".concat(testId, "-api-key"),
            value: apiKey,
            helperText: helperText,
            error: !!helperText,
            onClick: onCopyApiKey
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.stepsContainer,
          children: steps.slice(1).map((step, index) => /*#__PURE__*/_jsx(Typography, {
            children: step
          }, index))
        })]
      }), /*#__PURE__*/_jsxs(Button, _objectSpread(_objectSpread({
        skin: "primaryOutline",
        "data-testid": "go-to-".concat(testId),
        as: "a",
        suffixIcon: /*#__PURE__*/_jsx(NewTab, {}),
        href: integrationUrl
      }, openInNewTabProps), {}, {
        className: styles.goToContainer,
        children: ["Go to ", title]
      }))]
    }),
    primaryButtonLabel: "Close",
    onPrimaryButtonClick: dismissModal,
    onCloseButtonClick: dismissModal,
    "data-testid": "integrate-with-".concat(testId, "-modal")
  });
}